import { Component, Input, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LOCAL_STORAGE_LANG_KEY } from "@core/constants/app";
import { LogoutService } from "@core/services/logout.service";

@Component({
    selector: "app-language-selection",
    templateUrl: "./language-selection.component.html",
    standalone: false,
})
export class LanguageSelectionComponent implements OnDestroy {
    readonly translationPrefix = "common.formFieldsLabels";
    readonly backButtonTranslation = "wizard.actions.back";

    languages;
    languageForm: FormGroup;

    @Input() initialSetup = true;

    private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

    get languagePicker() {
        return this.languageForm.get("languagePicker");
    }

    constructor(
        private fb: FormBuilder,
        private languageService: TranslateService,
        private logoutService: LogoutService,
        public activeModal: NgbActiveModal,
    ) {
        this.languages = this.languageService.getLangs();

        this.languageForm = this.fb.group({
            languagePicker: [localStorage.getItem(LOCAL_STORAGE_LANG_KEY) || null, Validators.required],
        });

        this.languagePicker.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((lang: string) => this.languageService.use(lang));
    }

    submitSelection() {
        localStorage.setItem(LOCAL_STORAGE_LANG_KEY, this.languagePicker.value);
        this.activeModal.close();
    }

    logout(): void {
        this.logoutService.logout();
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
